var __jsx = React.createElement;
import React from "react";
import CommentIcon from "components/common/elsevier/Icons/CommentIcon";
import { ELSButton } from "components/common/elsevier/Button/Button";
import styles from "./Feedback.module.scss";
export default function Feedback() {
  var handleClick = function handleClick(event) {
    event.preventDefault();
    return false;
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "feedback-area",
    className: styles["feedback-area"]
  }, /*#__PURE__*/React.createElement(ELSButton, {
    id: "feedback-button",
    "aria-label": "Leave us your feedback",
    title: "Leave us your feedback",
    onClick: handleClick,
    className: "es-button es-button__primary ".concat(styles["feedback-button"]),
    "data-cy": "feedback-button"
  }, /*#__PURE__*/React.createElement(CommentIcon, null), "\xA0Feedback"));
}